import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { UtilityService } from "./utility.service";
import { AppComponent } from '../app.component';

@Injectable({
  providedIn: "root",
})
export class ApiService {
  base_blockchain = "https://aarogyaprahari.robomx.tech/";

  constructor(private http: HttpClient, public utility: UtilityService) {}

  Appref = AppComponent;
  saveData(data: string, disease: string) {
    this.http
      .post(this.base_blockchain + "addData", {
        "data": data,
        "disease": disease,
        "accno": UtilityService.AccNo || "UNKNOWN"
      })
      .subscribe((r) => {
        console.log(r)
      }, (e) => {
        console.log(e)
      });
  }

  sync(mnemonic: string, password: string) {
    this.http
      .post(this.base_blockchain + "sync", {
        mnemo: mnemonic,
        pass: password,
      })
      .subscribe(
        (r) => {
          console.log(r);
          if (r["Status"] && r["Status"] == 1) {
            this.utility.putUser(r["Acc_no"], r["Mnemonic"], r["Address"]);
            this.utility.presentToast(this.Appref.content.toast_msg[this.Appref.currentLang]['sync']);
          } else {
            this.utility.presentToast(this.Appref.content.toast_msg[this.Appref.currentLang]['sync_error']);
          }
        },
        (e) => {
          console.log(e);
          this.utility.presentToast(
            this.Appref.content.toast_msg[this.Appref.currentLang]['error']
          );
        }
      );
  }

  login(secure_key: string, password: string) {
    this.http
      .post(this.base_blockchain + "login", {
        add: secure_key,
        pass: password,
      })
      .subscribe(
        (r) => {
          // console.log(r);
          if (r["Status"] && r["Status"] == 1) {
            this.utility.putUser(r["accountno"], null, secure_key);
            this.utility.presentToast(this.Appref.content.toast_msg[this.Appref.currentLang]['inside']);
          } else {
            this.utility.presentToast(
              this.Appref.content.toast_msg[this.Appref.currentLang]['error']
            );
          }
        },
        (e) => {
          console.log(e);
          this.utility.presentToast(
            this.Appref.content.toast_msg[this.Appref.currentLang]['error']
          );
        }
      );
  }

  create(password: string) {
    try {
      this.http
        .post(this.base_blockchain + "create_acc", {
          pass: password,
        })
        .subscribe(
          (res) => {
            console.log(res);
            const m = res["Mnemonic"];
            const a = res["Acc_no"];

            // store in application data variable
            this.utility.putUser(a, m, res["Address"]);

            // notify user to store the mnemonic in a safe place
            this.utility.presentAlert(this.Appref.content.toast_msg[this.Appref.currentLang]["keep_safe"], m, "Copy");

            // copy text to clipboard
            this.utility.copyTextToClipboard(m);
          },
          (err) => {
            console.log(err);
          }
        );
    } catch (err) {
      console.log(err);
      this.utility.presentToast(this.Appref.content.toast_msg[this.Appref.currentLang]["create_error"]);
    }
  }
}
